<template>
  <v-card>
    <v-card-title class="pa-0">
      <v-spacer />
      <v-btn icon light @click="cancelDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="text-center">
      <div v-if="icon" class="pa-2">
        <v-icon x-large>{{ icon }}</v-icon>
      </div>

      <p v-if="header" class="headline">{{ header }}</p>

      {{ title }}
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: null,
    },
    header: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    loading: false,
  }),
  methods: {
    cancelDialog() {
      this.$emit('closeCancelParent');
    },
  },
};
</script>
